import {classes} from './bymo-page-viewer.st.css';

export function cssBymoPageViewerFixedFullSizeElement () {
    return classes.bymoPageViewerFixedFullSizeElement;
}